import { queryOptions } from "@tanstack/react-query";

import { getCoachMatchingAvailability } from "../services/getCoachMatchingAvailability";
import { CoachMatchingAvailabilityRequest } from "../types/CoachMatchingAvailabilityRequest";
import { emptyOnRejectedRange } from "../utils/emptyOnRejectedRange";

export const getCoachMatchingAvailabilityKeys = {
  root: ["getCoachMatchingAvailability"] as const,
  byInterval: (data: CoachMatchingAvailabilityRequest) =>
    [
      ...getCoachMatchingAvailabilityKeys.root,
      "availability",
      data.startDate,
      data.endDate,
    ] as const,
};

export const getCoachMatchingAvailabilityQuery = (
  data: CoachMatchingAvailabilityRequest,
) =>
  queryOptions({
    queryKey: getCoachMatchingAvailabilityKeys.byInterval(data),
    queryFn: () =>
      emptyOnRejectedRange(() => getCoachMatchingAvailability(data)),
    retry: false,
    refetchOnWindowFocus: (query) =>
      query.state.status !== "error" || query.state.data !== undefined,
    retryOnMount: false,
  });
